module.exports = __webpack_public_path__ + "img/study.8748a55.svg";